"use client";

import { useSiteConfig } from "@/lib/SiteConfigContext";

// The reviews section (design "#reviews"): warm-cream background, centered
// heading, and a three-column grid of testimonial cards (white, thin-ruled,
// with a large serif open-quote). Collapses to one column on mobile. Reviews
// are CMS-configurable (add / edit / remove in the admin Photos tab); the
// section hides itself if every review is removed.
export default function Testimonials() {
  const { reviews } = useSiteConfig();
  if (reviews.length === 0) return null;

  return (
    <section id="reviews" className="bg-cream-warm py-20 md:py-[84px]">
      <div className="container-xl">
        <div className="mb-[52px] text-center">
          <p className="eyebrow-plain mb-4">Client Reviews</p>
          <h2 className="font-serif text-4xl font-semibold leading-[1.05] text-navy sm:text-[44px]">
            Kind words from the Lowcountry.
          </h2>
        </div>

        <div className="grid gap-7 md:grid-cols-3">
          {reviews.map((t) => (
            <div
              key={t.id}
              className="border border-navy/[0.1] bg-white px-[30px] py-[34px]"
            >
              <div
                aria-hidden
                className="h-[26px] font-serif text-[60px] leading-[0.6] text-gold-light"
              >
                &ldquo;
              </div>
              <p className="mb-6 font-serif text-xl italic leading-[1.5] text-[#2b3a49]">
                {t.quote}
              </p>
              <div className="flex items-center gap-[10px] border-t border-navy/[0.1] pt-[18px]">
                <span className="h-px w-[22px] bg-gold" aria-hidden />
                <div>
                  <div className="text-sm font-semibold text-navy">
                    {t.author}
                  </div>
                  <div className="font-mono text-[11px] tracking-[0.05em] text-[#8a8474]">
                    {t.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
